import forEach from 'lodash/forEach';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import isObjectLike from 'lodash/isObjectLike';
import { SpecTypes } from '../../../constants';
import { isStringSpec } from '../../../helpers';
import { OBJECT_ARRAY_CNT, OBJECT_ARRAY_FLAG, SPEC_TYPE_FOR_GENERATE_BUTTON } from '../constants';
export const isCorrectConfig = (candidate) => Object.values(SpecTypes).every((type) => isObjectLike(candidate) &&
    isObjectLike(candidate[type]) &&
    isObjectLike(candidate[type].inputs) &&
    isObjectLike(candidate[type].layouts) &&
    isObjectLike(candidate[type].validators));
export const transformArrIn = (value) => {
    if (isArray(value)) {
        return value.reduce((arrObj, item, idx) => {
            arrObj[`<${idx}>`] = transformArrIn(item);
            return arrObj;
        }, { [OBJECT_ARRAY_FLAG]: true, [OBJECT_ARRAY_CNT]: value.length });
    }
    if (isObject(value)) {
        const _value = Object.assign({}, value);
        forEach(_value, (item, key) => {
            _value[key] = transformArrIn(item);
        });
        return _value;
    }
    return value;
};
export const transformArrOut = (value) => {
    if (isObject(value) && !isArray(value)) {
        if (value[OBJECT_ARRAY_FLAG]) {
            const _value = Object.keys(value)
                .filter((key) => key !== OBJECT_ARRAY_FLAG && key !== OBJECT_ARRAY_CNT)
                .map((key) => key.split('<').join('').split('>').join(''))
                .sort((a, b) => Number(a) - Number(b))
                .map((key) => transformArrOut(value[`<${key}>`]));
            return _value;
        }
        const _value = Object.assign({}, value);
        forEach(_value, (item, key) => {
            _value[key] = transformArrOut(item);
        });
        return _value;
    }
    return value;
};
export const isArrayItem = (name) => name[name.length - 1] === '>';
export const withGenerateButton = (spec) => isStringSpec(spec) &&
    SPEC_TYPE_FOR_GENERATE_BUTTON.includes(spec.viewSpec.type) &&
    spec.viewSpec.generateRandomValueButton;
